import { render, staticRenderFns } from "./ltzjjx7.vue?vue&type=template&id=21c7ec06&scoped=true&"
import script from "./ltzjjx7.vue?vue&type=script&lang=js&"
export * from "./ltzjjx7.vue?vue&type=script&lang=js&"
import style0 from "./ltzjjx7.vue?vue&type=style&index=0&id=21c7ec06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7ec06",
  null
  
)

export default component.exports